











































import { Component, Vue, Prop } from 'vue-property-decorator';
import RegistrationFooter from '../Registration/SignupFooter.vue';
import { vxm } from '@/store.vuex';
declare var window: any;
@Component({
  components: {
    RegistrationFooter,
  },
})
export default class Footer extends Vue {
  $wlToastr: any;
  private agreeTerms: boolean = false;
  private agreeReceiveEmail: boolean = false;
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }

  registerUser() {
    this.$emit('register-user');
  }

  updateMarketingEmailFlag() {
    vxm.roleSignup.setMarketingMail(this.agreeReceiveEmail);
  }
}
